import React from "react"
import classnames from "classnames"
import { P, H2, H5, H6 } from "AtomicComponents"
import styles from "./Testimonial.less"

class Testimonial extends React.PureComponent {
  render() {
    const { citizenName, citizenImageUrl, product, productImageUrl, options } = this.props
    return (
      <div className={classnames({
        [styles.Testimonial]: true
      })}>
        <div className={classnames({
          [styles.TestimonialColumns]: true
        })}>
          <div className={classnames({
            [styles.TestimonialColumn]: true,
            [styles.TestimonialColumnWhite]: true
          })}>
            <img src={citizenImageUrl} />
            <H6 withDetails>{citizenName}</H6>
          </div>
          <div className={classnames({
            [styles.TestimonialColumn]: true
          })}>
            <P withoutMargin>{product}</P>
            <img src={productImageUrl + '?width=240'} />
          </div>
          {
            options &&
            options.length &&
            options.map((option, index) => (
              <div className={classnames({
                [styles.TestimonialColumn]: true
              })}>
                <P withoutMargin>{option.name}</P>
                <div className={classnames({
                  [styles.TestimonialColumnValue]: true
                })}>
                  {index === 0 ? <H2 withDetails>{option.value}</H2> : <H5 withDetails>{option.value}</H5>}
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

export default Testimonial



// WEBPACK FOOTER //
// ./src/AtomicComponents/Testimonial/Testimonial.jsx